// extracted by mini-css-extract-plugin
export default {"InfoTooltipContainer":"InfoTooltip_InfoTooltipContainer__9jRa5","Tooltip":"InfoTooltip_Tooltip__swIO4"};